import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Premium from '@atlaskit/icon/glyph/premium';
import { token } from '@atlaskit/tokens';

import { Day } from '../Day';
import { useUserInfo } from '../../../store/userInfoStore';

const getElevenDaysAgo = () => {
	const elevenDaysAgo = new Date();
	elevenDaysAgo.setDate(elevenDaysAgo.getDate() - 11);
	return elevenDaysAgo;
};

export const FirstDay = () => {
	const { billingSourceSystem } = useUserInfo();
	const firstDayTitle = (
		<div>
			{billingSourceSystem === 'CCP' ? (
				<FormattedMessage
					id="end-of-trial-payment-modals.standard.timeline.start.title"
					defaultMessage="{start, date, long}: Standard trial begins"
					description="Title for trial start timeline item"
					values={{ start: getElevenDaysAgo() }}
				/>
			) : (
				<FormattedMessage
					id="end-of-trial-payment-modals.standard.timeline.start.title.no-date"
					defaultMessage="Standard trial begins"
					description="Title for trial start timeline item"
				/>
			)}
		</div>
	);

	const firstDaySubtitle = (
		<FormattedMessage
			id="end-of-trial-payment-modals.standard.timeline.start.subtitle"
			defaultMessage="Explore Standard’s powerful features."
			description="Subtitle for trial start timeline item"
		/>
	);

	return (
		<Day
			title={firstDayTitle}
			subtitle={firstDaySubtitle}
			icon={<Premium label="trial started" primaryColor={token('color.text.brand')} size="small" />}
		/>
	);
};
